
import axios from "axios";

import { API_URL } from "./conection";

export const saveImages = async (data) => {
  try {
    const sizeInBytes = new Blob([JSON.stringify(data)]).size;
    const sizeInMB = (sizeInBytes / 1024 / 1024).toFixed(2);
    console.log(`[saveImages] POST /save-images - IdForm: ${data.IdForm}, Tamaño: ${sizeInMB} MB`);

    const res = await axios.post(`${API_URL}/save-images`, data);
    console.log(`[saveImages] ✓ Respuesta exitosa:`, res.data);
    return res.data;
  } catch (error) {
    const status = error.response?.status;
    const axiosError = error.response?.data || error.message;
    console.error(`[saveImages] ✗ ERROR (${status || 'NETWORK'}):`, axiosError, error.message);
    if (status === 413) return { error: "payload_too_large" };
    if (status >= 500) return { error: "server_error" };
    if (!error.response) return { error: "network_error" };
    return null;
  }
};

export const updateImagesDB = async (idForm, data) => {
  try {
    const sizeInBytes = new Blob([JSON.stringify(data)]).size;
    const sizeInMB = (sizeInBytes / 1024 / 1024).toFixed(2);
    console.log(`[updateImagesDB] PUT /update-images/${idForm} - Tamaño: ${sizeInMB} MB`);

    const res = await axios.put(`${API_URL}/update-images/${encodeURIComponent(idForm)}`, data);
    console.log(`[updateImagesDB] ✓ Respuesta exitosa:`, res.data);
    return res.data;
  } catch (error) {
    const status = error.response?.status;
    const axiosError = error.response?.data || error.message;
    console.error(`[updateImagesDB] ✗ ERROR (${status || 'NETWORK'}):`, axiosError, error.message);
    if (status === 413) return { error: "payload_too_large" };
    if (status >= 500) return { error: "server_error" };
    if (!error.response) return { error: "network_error" };
    return null;
  }
};
export const getImages = async (idForm) => {
  try {
    console.log(`[getImages] GET /get-images/${idForm}`);
    const res = await axios.get(`${API_URL}/get-images/${encodeURIComponent(idForm)}`);

    const sizeInBytes = new Blob([JSON.stringify(res.data)]).size;
    const sizeInMB = (sizeInBytes / 1024 / 1024).toFixed(2);
    console.log(`[getImages] ✓ Encontrado (${sizeInMB} MB):`, res.data);
    return res.data;
  } catch (error) {
    const axiosError = error.response?.data || error.message;
    const status = error.response?.status;
    if (status === 404 || !error.response) {
      console.log(`[getImages] ℹ No encontrado para IdForm: ${idForm}`);
    } else {
      console.error(`[getImages] ✗ ERROR (${status || 'NETWORK'}):`, axiosError, error.message);
    }
    return null;
  }
};
